import ActionableLabel from './ActionableLabel';

export default ActionableLabel;
